'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdGroupWork = function MdGroupWork(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.6 29.1c2.3 0 4.3-1.8 4.3-4.1s-2-4.1-4.3-4.1-4.1 1.8-4.1 4.1 1.9 4.1 4.1 4.1z m-10.7-15.7c0 2.2 1.8 4.1 4.1 4.1s4.1-1.9 4.1-4.1-1.8-4.3-4.1-4.3-4.1 2-4.1 4.3z m-2.5 15.7c2.2 0 4.1-1.8 4.1-4.1s-1.9-4.1-4.1-4.1-4.3 1.8-4.3 4.1 2 4.1 4.3 4.1z m6.6-25.7c9.2 0 16.6 7.4 16.6 16.6s-7.4 16.6-16.6 16.6-16.6-7.4-16.6-16.6 7.4-16.6 16.6-16.6z' })
        )
    );
};

exports.default = MdGroupWork;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/group-work.js
// module id = 1593
// module chunks = 168707334958949